import * as React from "react";
import * as styles from "./styles";

interface IProps {
  icon?: JSX.Element;
  content: JSX.Element | string;
  style?: any;
}

const InfoBubble = (props: IProps) => {
  return (
    <div className={styles.InfoBubble} style={props.style}>
      {props.icon && <div>{props.icon}</div>}
      {props.content}
    </div>
  );
};

export default InfoBubble;
